import { SDUISectionInstanceRendererProps } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/__internal__/types";
import { SDUILayoutSectionRenderer } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/SectionRenderers/LayoutSection/SDUILayoutSectionRenderer";
import { IGetSDUIFilteredComponentsResponse } from "@faire/web-api--source/indigofair/data/IGetSDUIFilteredComponentsResponse";
import { ISection } from "@faire/web-api--source/indigofair/data/ISection";
import { useViewport } from "@faire/web/common/hooks/useViewport";
import React from "react";

export type IComponentsSectionProps = Pick<
  SDUISectionInstanceRendererProps,
  "componentRenderers" | "sectionLoggingData" | "UPLTprops"
> & {
  filteredComponents: IGetSDUIFilteredComponentsResponse;
  isPrimaryContent?: boolean;
};

export const ComponentsFlowLayoutSection: React.FC<IComponentsSectionProps> = ({
  filteredComponents,
  componentRenderers,
  sectionLoggingData,
  UPLTprops,
}) => {
  const viewport = useViewport();
  const section = ISection.build({
    layout_section: {
      components: filteredComponents.components,
      layout: filteredComponents.layout,
    },
  });

  return (
    <SDUILayoutSectionRenderer
      section={section}
      componentRenderers={componentRenderers}
      sectionLoggingData={sectionLoggingData}
      isFilterablePaginatedSection={true}
      viewport={viewport}
      UPLTprops={UPLTprops}
    />
  );
};
